import React, { useState } from 'react'
import SideDrawerMenu from '../../reusableComponents/sideDrawerMenu/sideDrawerMenu'
import './index.scss'
import logo from '../../../../../asset/smallandtrustlogo.png'
import SortModel from '../../../hunt-planner/reusableComponents/sortModel/sortModel'
import LandTrustItems from '../landtrustItems'
import { connect } from 'react-redux'
import Loader from '../../reusableComponents/loader/Loader'

const RightMenuBar = (props) => {
  const [sorting, setSorting] = useState(false)

  return (
    <SideDrawerMenu>
      <div className='lt-right-menu-bar'>

        <div className='lt-logo-sort-container'>
          <img className='lt-logo' src={logo}></img>

          {/* <div className='lt-sorting-container'>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <p className='ht-rt-menu-text sorting-style font-style-roboto-bold lt-lt-sorting-container-text'>Sort by</p>
            </div>

            <p className="arrow-container"
            //  onClick={() => { onSortClick() }}
            >
              <>
                <span className="arrow up"></span>
                <span className="arrow down"></span>
              </>
            </p>
          </div> */}

        </div>
        <div className='land-trust-Items-container'>
          <LandTrustItems loading={props.spinner}></LandTrustItems>
        </div>
        {props.spinner &&
          <Loader position={'absolute'} left={'42%'} width={'30px'}></Loader>
        }
      </div>
    </SideDrawerMenu>
  )
}



const mapStateToProps = state => ({
  privateLandItems: state.privateLandItems,
  privateLandFilterValues: state.privateLandFilterValues
})

const mapDispatchToProps = dispatch => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(RightMenuBar)